module.exports = __webpack_public_path__ + "static/media/image16.c6cb5aaa.jpg";